import { combineReducers } from '@reduxjs/toolkit';

import calendar from '~dashboard/components/user-calendar/reducers';

import alerts from './alerts';
import notifications from './notifications';
import prospects from './prospects';
import * as snapshotsReducers from './snapshots';

export const dashboard = {
  alerts,
  calendar,
  notifications,
  ...snapshotsReducers,
  prospects,
};

export default combineReducers(dashboard);
